import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import useValidation from "app/common/custom-hooks/useValidation";
import SpinnerButton from "app/common/components/SpinnerButton";
import FormInput from "app/common/components/FormInput";
import ResponsiveCol from "app/common/components/ResponsiveCol";
import { debounce, update } from "app/common/util/Helpers";
import toastMessage from "app/common/util/toastMessage";
import useActionListener from "app/common/custom-hooks/useActionListener";
import { login, register } from "app/redux/auth/authHandler";
import useQuery from "app/common/custom-hooks/useQuery";

const Step3 = ({setStepsData, email, isLoading}) => {

    const formRef = useRef();
    const dispatch = useDispatch();
    const queryInviteCode = useQuery("inviteCode");
    const teamInviteCode = useSelector(({auth}) => auth.invite?.inviteCode);
    const {validation, setValidation, markAsValidated, data} = useValidation(formRef);
    const defaultInviteCode = teamInviteCode || queryInviteCode;

    // Password fields compare
    const handleConfirmChange = debounce(_ => {
        const password = formRef.current?.querySelector('input[name="password"]').value;
        const confirmNewPassword = formRef.current?.querySelector('input[name="confirmNewPassword"]').value;
        const passEqual = (password === confirmNewPassword);
        setValidation(val => ({...val, allValid: passEqual ? val.allValid : false, fields: {...val.fields, confirmNewPassword: passEqual}}));
    }, 50);

    // Form Submission process
    const handleSubmit = _ => {
        // update(setStepsData, {step: 2})
        if (data.password === data.confirmNewPassword){
            const inviteMethod = data?.inviteCode && (defaultInviteCode ? "link" : "code");
            const payload = {...data, email, inviteMethod, name: `${data.firstName} ${data.lastName}`};
            update(setStepsData, payload);
            dispatch(register(payload));
        }
        else {
            toastMessage("error", "Confirm password not match")
        }
    }

    useActionListener("accountRegistered", _ => {
        dispatch(login({email, password: data?.password}));
    })

    return  <div className="-mt-10">
                <form onSubmit={handleSubmit} ref={formRef} onInput={handleConfirmChange}>
                    <h2
                        className="text-xl text-black-1 font-semibold pb-1.5"
                    >
                        Create your account
                    </h2>
                    <p
                        className="pb-5 text-grey-7"
                    >
                       Enter your personal information to get a Vendy account 
                    </p>
                    <ResponsiveCol className="">
                        <FormInput
                            label="First name:"
                            type='text' 
                            placeholder="Legal first name" 
                            required 
                            name="firstName"
                            validation={validation}
                            invalidMessage="Enter Legal first name"
                        />
                        <FormInput
                            label="Last name:"
                            type='text' 
                            placeholder="Legal last name" 
                            required 
                            name="lastName"
                            validation={validation}
                            invalidMessage="Enter Legal last name"
                        />
                        <FormInput
                            label="Phone number"
                            type='phone'  
                            name="phonenumber"
                            validation={validation}
                            invalidMessage="Enter a valid Phone Number"
                            colclass="sm:w-full"
                            required
                        />
                        <FormInput
                            label="Password"
                            type='password'  
                            name="password"
                            placeholder="Create a new password"
                            validation={validation}
                            invalidMessage="Enter valid password (Minimum of Eight Characters, One Uppercase, One Lowercase, One Number and One Symbol)"
                            colclass="sm:w-full"
                            onFocus={_ => validation.validated ? null : markAsValidated()}
                            required
                        />
                        <FormInput
                            label="Confirm Password"
                            type='password'  
                            name="confirmNewPassword"
                            placeholder="Re-enter password"
                            validation={validation}
                            invalidMessage="Confirm password not match"
                            colclass="sm:w-full"
                            required
                        />
                        <FormInput
                            label={<>Referral <span className="font-normal text-xs text-grey-4">(Optional)</span></>}
                            type='text'  
                            name="inviteCode"
                            placeholder="Enter Invite Code"
                            defaultValue={defaultInviteCode}
                            readOnly={!!defaultInviteCode}
                            colclass="sm:w-full"
                        />
                        <div
                            colclass="sm:w-full"
                            className="space-y-2 pt-2"
                        >
                            <FormInput
                                type='checkbox'  
                                name="agree"
                                validation={validation}
                                invalidMessage="Agree to terms of use."
                                required
                            >
                                <span className=" text-grey-8"> 
                                    I have read and agree to Vendy's  <a
                                        href="https://myvendy.com/terms-and-conditions"
                                        target="_blank"
                                        rel="noreferrer" 
                                        className="link font-normal"
                                    >Terms of Use</a>, <a 
                                        href="https://myvendy.com/privacy-policy"
                                        target="_blank"
                                        rel="noreferrer" 
                                        className="link font-normal"
                                    >Privacy Policy</a> and <a 
                                        href="https://myvendy.com/merchant-service-agreement"
                                        target="_blank"
                                        rel="noreferrer" 
                                        className="link font-normal"
                                    >Merchant Agreement</a> 
                                </span>
                            </FormInput>
                            <FormInput
                                type='checkbox'  
                                name="send-email"
                                validation={validation}
                            >
                                <span className=" text-grey-8"> Send me email updates on  new offers,  promotions, partnerships and new products by Vendy and it's partners </span>
                            </FormInput>
                        </div>
                        <SpinnerButton 
                                type="submit"  
                                colclass="sm:w-full"
                                disabled={!validation.allValid} 
                                className="w-full btn-primary btn-md" 
                                isLoading={isLoading}
                                text="Create account"
                            />
                        
                    </ResponsiveCol>
                    
                </form>
            </div>
}

export default Step3;